<section class="h-[90vh] md:h-[70vh] flex justify-center page-header">
    <div class="h-full w-full p-4 md:p-0 bg-gradient-to-r from-primary-dark/90 to-tertiary/70 bg-secondary/50">
        <div class="flex justify-center items-center h-full w-full">
            <div class="w-10/12">
                <div class="w-full">
                    <div class="flex flex-col text-center items-center">
                        <img src="logo.png" alt="logo" class="w-24 h-24 mb-4" />
                        <p class="text-5xl py-1 font-bold bg-gradient-to-r from-white to-blue-100 bg-clip-text text-transparent">
                          Bytes of Knowledge, Ideas of Tomorrow.
                        </p>
                        <p class="text text-white mt-5">
                            Read our student-published issues and fuel your tech knowledge
                        </p>
                        <div class="mt-10 flex items-center justify-center space-x-2">
                            <div class="flex -space-x-4">
                                <img class="w-10 h-10 border-2 border-white rounded-full" src="user-placefolder.jpg" alt="">
                                <img class="w-10 h-10 border-2 border-white rounded-full" src="user-placefolder.jpg" alt="">
                                <img class="w-10 h-10 border-2 border-white rounded-full" src="user-placefolder.jpg" alt="">
                                <a class="flex items-center justify-center w-10 h-10 text-xs font-medium text-white bg-gray-700 border-2 border-white rounded-full hover:bg-gray-600"
                                >+49</a>
                            </div>
        
                            <div class="h-10 border-l border-white mx-2"></div>
        
                            <p class="text-sm text-start text-white">From Students<br>To Students</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
